/**
 * @typedef {Object} Impression
 * @typedef {Object} Category
 * @property {string} id
 * @property {string} name
 * @property {string} price
 * @property {string} brand
 * @property {string} category
 * @property {string} list
 * @property {number} position
 */

/**
 * @typedef {Object} Product
 * @property {string} productId
 */

import { fetchExtraProductInfo } from "./fetch-extra-product-info.js";

/**
 * @param {string} userEmail
 * @param {Impression[] | Product[]} impressions
 * @param {Category} Category
 * @returns {*}
 */
export function createProductList(userEmail, impressions, Category) {
    return fetchExtraProductInfo(impressions.map(item => item.id))
      .then((itemExtraInfo) => {
          return itemExtraInfo.reduce((accumulator, extraInfo) => {
              return accumulator.set(extraInfo.elementXmlId, extraInfo);
          }, new Map())
      })
      .then((itemExtraInfoMap) => {
          return {
              'ecommerce': {
                  'email': userEmail,
                  'catID': Category.id,
                  'catName': Category.name,
                  'productsID': impressions.map((impression) => impression.id),
                  'impressions': impressions.map(impression => {
                    return {
                      ...impression,
                      'category': itemExtraInfoMap.get(impression.id).elementSectionPath,
                      'categoryId': itemExtraInfoMap.get(impression.id).elementSectionId,
                    };
                  })
              },
              'event': 'gtm-ee-event',
              'gtm-ee-event-category': 'Enhanced Ecommerce',
              'gtm-ee-event-action': 'Product Impressions',
              'gtm-ee-event-non-interaction': 'True',
          };
      });
}
